import React, { CSSProperties, ReactElement } from "react";
import { IElProps, IElState } from "../Interfaces";

class ContainerEl<
    P extends HTMLElement,
    S extends IElState
> extends React.Component<IElProps<P>, S> {
    __passPropsToChildren(props: IElProps<P>): React.ReactNodeArray {
        const children = React.Children.map(this.props.children, child => {
            if (child) {
                return React.cloneElement(child as ReactElement, { ...props });
            }
        });

        return children as React.ReactNodeArray;
    }

    __getFontUnit(): string {
        if (this.props.Brand) {
            return this.props.Brand.fontUnit;
        } else {
            return "px";
        }
    }

    __unitSize(value: number): string {
        return value + this.__getFontUnit();
    }

    __setStyle(styles: CSSProperties) {
        return Object.assign({}, this.props.style, styles);
    }
}

export { ContainerEl };
